export default __webpack_public_path__ + "static/media/shopping-icon.bd5f52e5.svg";